import type { Link } from 'models/link';
import type { RootState } from 'reducers/types';
import { requiresDocuments } from 'selectors/entities/documents/documents';
import { isCAP } from 'selectors/entities/recipient/recipient';
import {
  docCollectorFinished,
  shouldShowWhatsappSubscriptions,
} from 'selectors/ui/ui';

export const getLinkById = (state: RootState, id: string): Link | null => {
  const {
    entities: { links },
  } = state;

  return links[id] || null;
};

const getInitiateLink = (state: RootState, links: Record<string, Link>) => {
  const { initiate = null } = links;

  if (requiresDocuments(state) && !docCollectorFinished(state)) {
    return;
  }

  return initiate;
};

const getSmsNotificationLink = (
  state: RootState,
  links: Record<string, Link>,
) => {
  if (!links.sms_notification) {
    return;
  }
  if (isCAP(state)) {
    return;
  }
  if (shouldShowWhatsappSubscriptions(state)) {
    return;
  }

  return links.sms_notification;
};

const getReceiptLink = (state: RootState) => {
  return getLinkById(state, 'receipt');
};

export const getManagementLinks = (state: RootState): Record<string, Link> => {
  const {
    entities: { links },
  } = state;

  const initiate = getInitiateLink(state, links);
  const cancellation = getLinkById(state, 'cancellation');
  const smsNotification = getSmsNotificationLink(state, links);
  const receipt = getReceiptLink(state);
  const guaranteedReceipt = getLinkById(state, 'guaranteed_receipt');
  const booking = getLinkById(state, 'booking');

  return {
    ...(initiate && { initiate }),
    ...(cancellation && { cancellation }),
    ...(smsNotification && { sms_notification: smsNotification }),
    ...(receipt && { receipt }),
    ...(guaranteedReceipt && { guaranteedReceipt }),
    ...(booking && { booking }),
  };
};
